import { Box, Typography, Link } from '@mui/material'
import { motion } from 'framer-motion'
import KeyboardArrowUpOutlined from '@mui/icons-material/KeyboardArrowUpOutlined'
import { Facebook } from '@mui/icons-material'
import InstagramIcon from '@mui/icons-material/Instagram'
const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: 'secondary.main',
        color: 'white',
        textAlign: 'center',
        py: 2,
        // mt: 4,
      }}
    >
      <Typography variant="body2">
        Amman:{' '}
        <Link href="tel:+962796000941" color="inherit">
          +962796000941
        </Link>{' '}
        | Aqaba :{' '}
        <Link href="tel:+962799151843 " color="inherit">
          +962799151843
        </Link>{' '}
        | Email:{' '}
        <Link href="mailto:Sales4@nairoukhtravel.com" color="inherit">
          Sales4@nairoukhtravel.com
        </Link>{' '}
        | Email:{' '}
        <Link href="mailto:Aqaba@nairoukhtravel.com" color="inherit">
          Aqaba@nairoukhtravel.com
        </Link>
      </Typography>
      <Typography variant="body2" sx={{ mt: 1 }}>
        Mr. Mutasim Alkelany: Tel:{' '}
        <Link href="tel:+962795946909" color="inherit">
          +962795946909
        </Link>{' '}
        |
      </Typography>
      <br />
      <Link
        href="https://www.facebook.com/profile.php?id=100057140783565&mibextid=wwXIfr&rdid=r5hpAhEY65DCvRhv&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1BdmdJwp87%2F%3Fmibextid%3DwwXIfr#"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          textDecoration: 'none',
          color: '#fff',
        }}
      >
        <Facebook />
      </Link>
      <Link
        href="https://www.instagram.com/nairoukh_travel_jo/"
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: 'none', color: '#fff' }}
      >
        <InstagramIcon />
      </Link>
      <Typography variant="body2" sx={{ mt: 2 }}>
        Nairoukh Travel & Tourism &copy; {new Date().getFullYear()}
      </Typography>
      <motion.div
        animate={{
          y: [0, 10, 0],
        }}
        transition={{
          duration: 1.5,
          repeat: Infinity,
          repeatType: 'reverse',
        }}
        style={{
          position: 'fixed',
          bottom: '2rem',
          right: '2rem',
          cursor: 'pointer',
          zIndex: 1000,
        }}
        onClick={() => {
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          })
        }}
      >
        <KeyboardArrowUpOutlined
          sx={{
            fontSize: '3rem',
            color: '#fff',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            borderRadius: '50%',
            padding: '8px',
            '&:hover': {
              color: '#000',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
            },
          }}
        />
      </motion.div>
    </Box>
  )
}

export default Footer
